import work_1 from "../../assets/images/projects/work1.jpg"
import work_2 from "../../assets/images/projects/work2.jpg"
import work_3 from "../../assets/images/projects/work3.jpg"
import work_4 from "../../assets/images/projects/work4.jpg"
import work_5 from "../../assets/images/projects/work5.jpg"
import work_6 from "../../assets/images/projects/work6.jpg"

export const projectsData = [
    {
        id: 1,
        src: work_1,
        category: "Desarrollo",
        title: "TradeIt!",
        link: "https://github.com/marcuspkz/TradeIt"
    },
    {
        id: 2,
        src: work_2,
        category: "Desarrollo",
        title: "PokeViewer",
        link: "https://github.com/marcuspkz/PokeViewer"
    },
    {
        id: 3,
        src: work_3,
        category: "Desarrollo",
        title: "Mi portfolio ;)",
        link: "/"
    },
    {
        id: 4,
        src: work_4,
        category: "Marketing y SEO",
        title: "Contenidos en YouTube",
        link: "https://www.youtube.com/@MarcusPkZ/featured"
    },
    {
        id: 5,
        src: work_5,
        category: "Marketing y SEO",
        title: "Promoción online YouTube",
        link: "https://www.youtube.com/watch?v=Am3f21Q0Z9U"
    },
    {
        id: 6,
        src: work_6,
        category: "Marketing y SEO",
        title: "Optimización SEO en web VISCO",
        link: "https://visco.uno/"
    }
]